import React from "react";
import { Button, Text, Title, Rows } from "@canva/app-ui-kit";

interface ConnectProps {
  onConnect: () => void;
  error?: string;
  loading?: boolean;
}

export function ConnectScreen({ onConnect, error, loading }: ConnectProps) {
  return (
    <Rows spacing="2u">
      <Title size="medium">Profitual</Title>
      <Text>
        Pull live financial data into your pitch deck — revenue, burn rate,
        runway, charts, and more.
      </Text>
      {error && (
        <Text tone="critical" size="small">
          {error}
        </Text>
      )}
      <Button
        variant="primary"
        onClick={onConnect}
        loading={loading}
        stretch
      >
        Connect to Profitual
      </Button>
    </Rows>
  );
}
